/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import { useCallback, useEffect, useState } from 'react';
import { Input } from 'tdesign-react';

import styles from './index.module.less';

interface IProps {
  onChange: (value: string) => void;
  value: string;
  disabled: boolean;
}

const ItemComp: React.FC<IProps> = (props) => {
  const { value, disabled, onChange } = props;
  const [val, setVal] = useState<string>('');

  useEffect(() => {
    setVal(value);
  }, [value]);

  const handleChange1 = useCallback((val: string) => {
    setVal(val);
    onChange(val);
  }, [onChange]);

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <Input value={val} disabled={disabled} onChange={handleChange1} />
      </div>
    </div>
  );
};

export default ItemComp;
